<template>
  <b-card class="chat-type-selector">
    <b-card-title class="mb-2">
      <feather-icon class="mr-50" icon="MessageSquareIcon" size="24"/>
      Choisir le type d'assistance IA
    </b-card-title>

    <b-card-text class="text-muted mb-3">
      Sélectionnez le type de document que vous souhaitez générer avec l'IA
    </b-card-text>

    <b-row>
      <!-- Report Option -->
      <b-col cols="12" md="6">
        <b-card
            :class="{ 'border-primary': selectedType === 'rapport' }"
            class="chat-type-option cursor-pointer"
            no-body
            @click="selectType('rapport')"
        >
          <b-card-body class="text-center p-2">
            <div class="chat-type-icon mb-1 text-primary">
              <feather-icon icon="FileTextIcon" size="48"/>
            </div>
            <h4 class="mb-1">Génération de Rapport</h4>
            <p class="text-muted mb-0">
              Chargez vos fichiers (PDF, Word, Excel) et l'IA vous aidera à générer un rapport complet
            </p>
            <div class="mt-1">
              <b-badge class="mr-50" variant="light-primary">
                <feather-icon class="mr-25" icon="FileIcon" size="14"/>
                PDF
              </b-badge>
              <b-badge class="mr-50" variant="light-primary">
                <feather-icon class="mr-25" icon="FileIcon" size="14"/>
                Word
              </b-badge>
              <b-badge variant="light-primary">
                <feather-icon class="mr-25" icon="FileIcon" size="14"/>
                Excel
              </b-badge>
            </div>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- CV Option -->
      <b-col cols="12" md="6">
        <b-card
            :class="{ 'border-success': selectedType === 'cv' }"
            class="chat-type-option cursor-pointer"
            no-body
            @click="selectType('cv')"
        >
          <b-card-body class="text-center p-2">
            <div class="chat-type-icon mb-1 text-primary">
              <feather-icon icon="UserIcon" size="48"/>
            </div>
            <h4 class="mb-1">Génération de CV</h4>
            <p class="text-muted mb-0">
              Chargez un modèle de CV et répondez aux questions pour créer votre CV personnalisé
            </p>
            <div class="mt-1">
              <b-badge class="mr-50" variant="light-success">
                <feather-icon class="mr-25" icon="FileIcon" size="14"/>
                Word
              </b-badge>
              <b-badge variant="light-success">
                <feather-icon class="mr-25" icon="FileIcon" size="14"/>
                PDF
              </b-badge>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <div v-if="selectedType" class="mt-2 text-center">
      <b-button
          :disabled="!selectedType"
          size="lg"
          variant="primary"
          @click="confirmSelection"
      >
        <feather-icon class="mr-50" icon="ArrowRightIcon"/>
        Continuer avec {{ selectedType === 'rapport' ? 'Rapport' : 'CV' }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {BBadge, BButton, BCard, BCardBody, BCardText, BCardTitle, BCol, BRow} from 'bootstrap-vue'

export default {
  name: 'ChatTypeSelector',
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BBadge
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedType: this.value
    }
  },
  watch: {
    value(newVal) {
      this.selectedType = newVal
    }
  },
  methods: {
    selectType(type) {
      this.selectedType = type
      this.$emit('input', type)
    },
    confirmSelection() {
      if (this.selectedType) {
        this.$emit('confirm', this.selectedType)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-type-selector {
  max-width: 900px;
  margin: 0 auto;
}

.chat-type-option {
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }
}
</style>
